<div class="container" fxLayout="row wrap" fxLayoutAlign="space-between start">
  <div class="configuration-panel" fxLayout="column" fxFlex="100">
    <mat-card
      *ngIf="renderStatus && renderStatus === homeStatusEnum.InProgress && !(groundFloorAvailable || firstFloorAvailable || secondFloorAvailable)"
      class="mat-card-inline-sm banner-info" fxFlex="100">
      <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
        <span class="text-info">Rendering your home..</span>
        <div class="progress" fxLayout="row" fxLayoutAlign="end center">
          <div class="description">{{ renderStatusDescription }}</div>
          <div class="panorama-loading-progress">
            <div>
              <mat-spinner [diameter]="40">
              </mat-spinner>
              <div class="loading-value">
                {{ renderStatusProgress }}
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card
      *ngIf="renderStatus && renderStatus === homeStatusEnum.Queued && !(groundFloorAvailable || firstFloorAvailable || secondFloorAvailable)"
      class="mat-card-inline-sm banner-info" fxFlex="100">
      <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
        <span class="text-info">Your home is queued for rendering...</span>
        <div>{{ renderStatusDescription }}</div>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="renderStatus && renderStatus === homeStatusEnum.Failed" class="mat-card-inline-sm banner-warning"
      fxFlex="100">
      <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
        <span class="text-warning">Sorry! We failed to render this home. Please try again....{{
          renderStatusDescription }}</span>
        <mat-icon class="link" (click)="clearFailure()">clear</mat-icon>
      </mat-card-content>
    </mat-card>
    <div>
      <div id="viewer-readonly" class="viewer" fxFlex="100" [style.height]="viewerHeight">
        <div *ngIf="!displayOnly" class="panorama-top-overlay" fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex="50" id="panorama-controls" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-icon class="icon-display link" matTooltip="Open/Close Fullscreen" matTooltipPosition="below"
              (click)="toggleFullscreen()" aria-hidden="false" aria-label="fullscreen">
              fullscreen
            </mat-icon>
            <mat-icon *ngIf="deviceHasGyro" class="icon-display link" matTooltip="Toggle Gyro" (click)="toggleGyro()"
              matTooltipPosition="below" aria-hidden="false" aria-label="toggleGyro">
              3d_rotation
            </mat-icon>
            <mat-icon class="icon-display" [class.link]="!showFloorPlan" [class.disable-link]="showFloorPlan"
              matTooltip="Toggle Floorplan" (click)="toggleFloorplan()" matTooltipPosition="below" aria-hidden="false"
              aria-label="toggleFloorplan">
              map
            </mat-icon>
            <mat-icon class="icon-display link" matTooltip="Share this location" aria-label="shareLocation"
              (click)="copyDebugUrl()" matTooltipPosition="below" aria-hidden="false">
              share_location
            </mat-icon>
            <mat-icon *ngIf="historyToggle" class="icon-display link" [matTooltip]="latestVersionAvailable ? 'History available' : 'No history available'" aria-label="shareLocation"
            [color]="latestVersionAvailable ? 'primary' : 'basic'"matTooltipPosition="below" aria-hidden="false" color="primary">
              new_releases
            </mat-icon>
            <mat-icon *ngIf="linkToPortal" class="icon-display link" matTooltip="View in situPORTAL" aria-label="viewInPortal" 
              (click)="openInPortal()" matTooltipPosition="below" aria-hidden="false">
              exit_to_app
            </mat-icon>
          </div>
          <div fxFlex="50" *ngIf="renderStatus" class="progress" fxLayout="row" fxLayoutAlign="end center">
            <div fxHide="false" fxHide.lt-md="true" class="description">{{ renderStatusDescription }}</div>
            <div class="panorama-loading-progress">
              <div>
                <mat-spinner [diameter]="40">
                </mat-spinner>
                <div class="loading-value">
                  {{ renderStatusProgress }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div [fxShow]="showFloorPlan && (groundFloorAvailable || firstFloorAvailable || secondFloorAvailable)"
          class="panorama-overlay-floorplan">
          <div>
            <button *ngIf="groundFloorAvailable" mat-button (click)="selectFloorPlan(0)">
              Ground
            </button>
            <button *ngIf="firstFloorAvailable" mat-button (click)="selectFloorPlan(1)">
              First
            </button>
            <button *ngIf="secondFloorAvailable" mat-button (click)="selectFloorPlan(2)">
              Second
            </button>
          </div>
          <div [fxShow]="showFloorPlan && selectedFloorPlan === 0" id="ground-floor-plan"></div>
          <div [fxShow]="showFloorPlan && selectedFloorPlan === 1" id="first-floor-plan"></div>
          <div [fxShow]="showFloorPlan && selectedFloorPlan === 2" id="second-floor-plan"></div>
        </div>
      </div>
    </div>
    
    <div *ngIf="!displayOnly" class="homeconfig" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
      <a target="_blank" href="https://situsystems.com/"><img class="logo" src="https://cdn.situsystems.com/facade/2d7f08ea-ccdc-4c39-85ce-4e987ea79e65.png" alt="situSYSTEMS" matTooltip="situSYSTEMS"></a> 
    </div>
    <div *ngIf="!displayOnly && historyToggle && latestVersionAvailable" class="history-container">
      <div class="templates-container" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
        <button class="m-b-20" *ngIf="!showHistory" mat-icon-button style="transform: scale(2);" color="primary" (click)="showHistory = true">
          <mat-icon>new_releases</mat-icon>
        </button>
        <div *ngIf="showHistory" fxHide.lt-sm class="main-thumbnail-container">
          <img [src]="getThumbnailUrl(currentHistoryIndex)" class="thumbnail-selected">
          <small class="date">{{ getVersionDate(currentHistoryIndex) | date:'short' }}</small>
          <mat-icon *ngIf="currentHistoryIndex !== originalArtifactId" (click)="loadThisVersion(originalArtifactId)" class="white-icon link" matTooltip="Reload original version">outlined_flag</mat-icon>
        </div>
        <button *ngIf="showHistory" mat-icon-button color="accent" [disabled]="scrollLeftDisabled()" (click)="scrollLeft()">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div *ngIf="showHistory" class="select-thumbnail-container" (click)="currentHistoryIndex !== rightHistoryThumbIndex && loadThisVersion(rightHistoryThumbIndex)">
          <img [src]="getThumbnailUrl(rightHistoryThumbIndex)" class="thumbnail" matTooltip="Created {{ getVersionDate(rightHistoryThumbIndex) | date:'short' }}">
          <small class="date">{{ getVersionDate(rightHistoryThumbIndex) | date:'short' }}</small>
          <div class="icon-container" fxLayout="row" fxLayoutAlign="end center">
            <mat-icon *ngIf="rightHistoryThumbIndex !== currentHistoryIndex" matTooltip="Load version" class="text-info">radio_button_unchecked</mat-icon>
            <mat-icon *ngIf="rightHistoryThumbIndex === currentHistoryIndex" class="text-success" matTooltip="Selected version">radio_button_checked</mat-icon>
            <mat-icon *ngIf="rightHistoryThumbIndex === originalArtifactId" class="white-icon" matTooltip="Original version">flag</mat-icon>
            <mat-icon *ngIf="rightHistoryThumbIndex === latestHistoryIndex" color="primary" matTooltip="Latest version">new_releases</mat-icon>
          </div>
          <mat-icon class="close link" color="primary" matTooltip="Close history" (click)="showHistory = false">clear</mat-icon>
        </div>
        <button *ngIf="showHistory" mat-icon-button color="accent" [disabled]="scrollRightDisabled()" (click)="scrollRight()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
